import React from 'react';
// Chỉ import CSS của suneditor (không kéo theo suneditor-react) để phần preview body
// hiển thị đúng typography của editor — xem class sun-editor-editable bên dưới.
import 'suneditor/dist/css/suneditor.min.css';
import { mergeTemplateBody } from '../../../utils/CommonUtils';
import { htmlToPlainText } from '../../../utils/StringUtils';
import { resolvePersonalization } from '../../../utils/PersonalizationUtils';
import { selectTemplateBody } from '../../../utils/MailTemplateUtils';

const EmailDraftContent = ({ candidate, selectedTemplate, selectedEmailsProp, onEmailListChange }) => {
  const personal = candidate?.personal || {};
  const location = candidate?.location || {};
  const knowState = candidate?.flow_categories?.candidate_know_state;

  // [SPEC: TEST Gửi Email qua PM - DVTJCUV 4: EE9] R5 — tên UV lấy từ "Tên (email)" (email_name).
  // KHÔNG fallback sang full_name: Person thiếu email_name bị đẩy sang tab "Thiếu thông tin"
  // ở DraftPreviewModal nên không bao giờ gửi ra email với chỗ tên bị trống.
  const displayName = personal.email_name || '';

  const { callerName, vocative } = resolvePersonalization(personal, location);

  const mergedBody = mergeTemplateBody(selectTemplateBody(selectedTemplate, knowState), {
    caller_name_to_email: callerName,
    vocative,
    email_name: displayName,
    // [SPEC: TEST Gửi Email qua PM - DVTJCUV 4: EE9] {{Tên ứng viên}} map về key `full_name`
    // trong MAIL_MERGE_FIELDS nên phải điền email_name vào ĐÚNG key này. Không đổi label
    // trong registry: template đã lưu chứa chuỗi nhãn "Tên ứng viên", đổi label sẽ làm
    // placeholder cũ fill rỗng (mất tên UV trong email).
    full_name: displayName,
  });

  // Subject soạn bằng SunEditor nên là HTML; header của email chỉ nhận text thuần.
  const mergedSubject = htmlToPlainText(mergeTemplateBody(selectedTemplate?.subject || '', {
    caller_name_to_email: callerName,
    vocative,
    email_name: displayName,
    // [SPEC: TEST Gửi Email qua PM - DVTJCUV 4: EE9] {{Tên ứng viên}} map về key `full_name`
    // trong MAIL_MERGE_FIELDS nên phải điền email_name vào ĐÚNG key này. Không đổi label
    // trong registry: template đã lưu chứa chuỗi nhãn "Tên ứng viên", đổi label sẽ làm
    // placeholder cũ fill rỗng (mất tên UV trong email).
    full_name: displayName,
  }));

  const selectedEmails = selectedEmailsProp || [];

  const handleRemoveEmail = (index) => {
    const next = [...selectedEmails];
    if (next.length === 1) {
      onEmailListChange([]);
    } else {
      next.splice(index, 1);
      onEmailListChange(next);
    }
  };

  return (
    <div className="p-3">
      {/* Person header */}
      <div className="mb-3 d-flex flex-wrap" style={{ gap: '24px' }}>
        <div><strong>Tên:</strong> {displayName}</div>
        <div><strong>Gọi Person là:</strong> {callerName || <em>(trống)</em>}</div>
        <div><strong>User xưng là:</strong> {vocative || <em>(trống)</em>}</div>
      </div>

      {/* Email recipient list — read-only: chỉ được xóa, không cho thêm mới */}
      <div className="mb-3">
        <label className="font-weight-bold d-block mb-1">Email nhận:</label>
        <div className="w-100 d-flex flex-wrap" style={{ gap: '8px' }}>
          {selectedEmails.length === 0 ? (
            <span className="text-danger"><em>(Trống)</em></span>
          ) : (
            selectedEmails.map((email, index) => (
              <span
                key={email}
                className="badge badge-secondary d-flex align-items-center"
                style={{ fontSize: '0.9rem', padding: '6px 10px' }}
              >
                {email}
                <button
                  type="button"
                  aria-label={`remove-${email}`}
                  className="btn btn-sm p-0 ml-2 border-0 bg-transparent"
                  onClick={() => handleRemoveEmail(index)}
                >
                  <i className="fas fa-times" />
                </button>
              </span>
            ))
          )}
        </div>
      </div>

      {/* Email Subject */}
      <div className="mb-3">
        <label className="font-weight-bold d-block mb-1">Subject (Tiêu đề):</label>
        <input
          type="text"
          className="form-control"
          value={mergedSubject}
          readOnly
        />
      </div>

      {/* Merged email body */}
      <div>
        <label className="font-weight-bold d-block mb-1">Nội dung email:</label>
        {/* sun-editor-editable: dùng lại đúng font/line-height/margin của editor, nếu không
            thẻ <p> sẽ ăn margin-bottom 1rem của Bootstrap và các dòng bị giãn xa hơn template. */}
        <div
          data-testid="email-body"
          className="sun-editor-editable p-3 border rounded bg-white"
          style={{ minHeight: '200px', overflowY: 'auto' }}
          dangerouslySetInnerHTML={{
            __html: mergedBody || '<em>(Không có nội dung template)</em>',
          }}
        />
      </div>
    </div>
  );
};

export default EmailDraftContent;
